import { api } from '../helpers/api';

export enum SocialSourceType {
    GOOGLE = 'GOOGLE',
    FACEBOOK = 'FACEBOOK',
    YELP = 'YELP',
    INSTAGRAM = 'INSTAGRAM',
  }

export type SocialMediaBody = {
  socialMediaId: string;
  enable: boolean;
  sourceType: string;
  url: string;
};

const settingApis = {
  getSettingSocialMedia: async (id: string) => {
    return await api.get(`/api/v1/admin/setting/${id}/get-social-media`);
  },
  updateSettingSocialMedia: async (id: string, body: SocialMediaBody[]) => {
    return await api.put(`/api/v1/admin/setting/${id}/update-social-media`, body);
  },
};

export default settingApis;
